import {
  Box,
  FloraButton as Button,
  Drawer,
  DrawerCloseButton,
  DrawerContent,
} from "@grupoboticario/flora-react";

import {
  ChevronDownIcon,
  TwoPeopleCircleIcon,
} from "@grupoboticario/flora-react-icons";
import React from "react";
import AuthContext from "mfeAuth/AuthContext";
import { useHistory } from "react-router-dom";
import { LinkMenu, SideMenuList, SubItemMenu } from "./style";
import FloraIcon from "../FloraIcon";

export function DrawerProfile() {
  const { logout, claim } = React.useContext<{
    claim: { email: string; name: string };
    logout: () => void;
  }>(AuthContext);

  const [isOpen, setOpen] = React.useState(false);
  const toggle = () => setOpen(!isOpen);
  let history = useHistory();

  function navigator(path: string) {
    history.push(path);
    toggle();
  }

  return (
    <>
      <Button
        has="iconRight"
        icon={<ChevronDownIcon />}
        css={{ "& svg": { marginLeft: "0 !important" } }}
        style={{ background: "transparent" }}
        onClick={toggle}
      >
        <TwoPeopleCircleIcon />
      </Button>

      <Drawer open={isOpen} onOpenChange={toggle}>
        <DrawerContent
          side="right"
          style={{ padding: 0 }}
          css={{ maxWidth: 300 }}
        >
          <DrawerCloseButton />
          <div>
            <Box
              css={{
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
                justifyContent: "center",
                background: "#364372",
                height: "150px",
                padding: "$8",
                fontSize: "$bodyLarge",
                fontFamily: "$body",
                color: "#FFFFFF",
                textAlign: "center",
                gap: "$1",
                marginBottom: "$4",
              }}
            >
              <TwoPeopleCircleIcon size="40" color="$actionableAlt" />
              <strong>{claim.name}</strong>
              <span style={{ fontSize: "12px" }}> {claim.email}</span>
            </Box>
            <SideMenuList>
              {/* <SubItemMenu>
              <LinkMenu onClick={() => null}>
                <FloraIcon iconText={"PencilIcon"} />
                Perfil
              </LinkMenu>
            </SubItemMenu> */}
              <SubItemMenu>
                <LinkMenu onClick={logout}>
                  <FloraIcon iconText={"ArrowCurveUpIcon"} />
                  Sair
                </LinkMenu>
              </SubItemMenu>
            </SideMenuList>
          </div>
        </DrawerContent>
      </Drawer>
    </>
  );
}
